(() => {
  'use strict';

    // Hide product grid immediately when pin parameter exists.
  const hasPinParam = new URLSearchParams(window.location.search).has('pin');

  if (hasPinParam) {
    document.documentElement.classList.add('has-pin-param');
  }

  const SELECTORS = {
    gridContainer: '#ProductGridContainer',
    collection: '#product-grid',
    productList: '#product-grid ul.product-grid, #product-grid ul.grid, #product-grid .product-grid',
    gridItem: '.grid__item',
    pagination: '.pagination',
    nextLink: '.pagination a.pagination__item--next',
  };

  const ROOT_MARGIN = '100px 0px';

  // ---------------------------------------------------------------------------
  // pin= param parsing
  // Format: pin=<id>,<id>,type:<type>,vendor:<vendor>,tag:<tag>
  // tag: values may contain colons, e.g. tag:offer:new-arrival
  //
  // Priority logic:
  // 1. ID pins resolve first, in the exact left-to-right order they appear in pin=.
  // 2. Attribute pins (type:, vendor:, tag:) resolve next, in left-to-right rule
  //    order. Within each rule, products keep their original collection order.
  // 3. Dedup: a product matched by both an ID pin and an attribute rule stays
  //    only in the ID group. A product matching two attribute rules stays only
  //    in the first matching rule's group.
  // 4. Unpinned remainder comes last, in collection/sort_by order.
  // 5. Filters (brand=, filter.p.tag=) apply upstream of this: Shopify's own
  //    section render already excludes filtered-out products from the fetched
  //    HTML, so a pinned product failing an active filter is simply absent
  //    from `list` and never gets a priority slot — no explicit drop needed.
  // ---------------------------------------------------------------------------

  function normalizeToken(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function normalizeHandle(value) {
    return normalizeToken(value).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  // function parsePinParam() {
  //   const pinValue = new URLSearchParams(window.location.search).get('pin') || '';
  //   const items = pinValue.split(',').map((s) => s.trim()).filter(Boolean);

  //   const productIds = [];
  //   const typeRules = [];
  //   const vendorRules = [];
  //   const tagRules = [];
  //   const orderedRules = [];

  //   items.forEach((item) => {
  //     const lower = item.toLowerCase();
  //     if (lower.indexOf('type:') === 0) {
  //       const value = normalizeToken(item.slice(5));
  //       typeRules.push(value);
  //       orderedRules.push({ kind: 'type', value });
  //     } else if (lower.indexOf('vendor:') === 0) {
  //       const value = normalizeToken(item.slice(7));
  //       vendorRules.push(value);
  //       orderedRules.push({ kind: 'vendor', value });
  //     } else if (lower.indexOf('tag:') === 0) {
  //       const value = normalizeToken(item.slice(4));
  //       tagRules.push(value);
  //       orderedRules.push({ kind: 'tag', value });
  //     } else {
  //       productIds.push(normalizeToken(item));
  //     }
  //   });

  //   return { productIds, typeRules, vendorRules, tagRules, orderedRules };
  // }
  function parsePinParam() {
  const pinValue = new URLSearchParams(window.location.search).get('pin') || '';

  const items = pinValue
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);

  const productIds = [];
  const typeRules = [];
  const vendorRules = [];
  const tagRules = [];
  const orderedRules = [];

  items.forEach((item) => {
    // Support both:
    // vendor:AT01
    // vendor\:AT01
    //
    // Also supports:
    // type:Shirts
    // type\:Shirts
    // tag:New
    // tag\:New
    const normalizedItem = item.replace(/\\:/g, ':');
    const lower = normalizedItem.toLowerCase();

    if (lower.indexOf('type:') === 0) {
      const value = normalizeToken(normalizedItem.slice(5));

      if (value) {
        typeRules.push(value);
        orderedRules.push({
          kind: 'type',
          value
        });
      }

    } else if (lower.indexOf('vendor:') === 0) {
      const value = normalizeToken(normalizedItem.slice(7));

      if (value) {
        vendorRules.push(value);
        orderedRules.push({
          kind: 'vendor',
          value
        });
      }

    } else if (lower.indexOf('tag:') === 0) {
      const value = normalizeToken(normalizedItem.slice(4));

      if (value) {
        tagRules.push(value);
        orderedRules.push({
          kind: 'tag',
          value
        });
      }

    } else {
      productIds.push(normalizeToken(normalizedItem));
    }
  });

  return {
    productIds,
    typeRules,
    vendorRules,
    tagRules,
    orderedRules
  };
}

  function hasActivePinRules(pinRules) {
    return (
      pinRules.productIds.length > 0 ||
      pinRules.typeRules.length > 0 ||
      pinRules.vendorRules.length > 0 ||
      pinRules.tagRules.length > 0
    );
  }

  // Returns the sort slot for a grid item against the pin rules.
  // Lower slot = sorted earlier. Infinity = not pinned, keep collection order.
  // Reads: data-product-id, data-product-type, data-product-vendor,
  // data-product-vendor-handle (optional), data-product-tags (comma-separated).
  // Confirmed present on the Dawn collection grid <li>, e.g.:
  //   <li data-product-id="8246290153625" data-product-type="Formal Pants"
  //       data-product-vendor="MB20" data-product-vendor-handle="mb20"
  //       data-product-tags="NEW,MB20,Active,..." class="grid__item ...">
  
  function getPinPriority(item, pinRules) {
    const productId = normalizeToken(item.dataset.productId);
    let i;

    for (i = 0; i < pinRules.productIds.length; i++) {
      if (productId === pinRules.productIds[i]) return i;
    }

    const productType = normalizeToken(item.dataset.productType);
    const vendor = normalizeToken(item.dataset.productVendor);
    // Prefer the theme's own vendor handle (data-product-vendor-handle) when present —
    // it's Shopify's canonical slug and handles apostrophes/unicode correctly.
    // Fall back to a client-side slugify only if the attribute is missing.
    const vendorHandle = item.dataset.productVendorHandle
      ? normalizeToken(item.dataset.productVendorHandle)
      : normalizeHandle(item.dataset.productVendor);
    const tags = (item.dataset.productTags || '').split(',').map(normalizeToken);

    for (i = 0; i < pinRules.orderedRules.length; i++) {
      const rule = pinRules.orderedRules[i];
      const matches =
        (rule.kind === 'type' && productType === rule.value) ||
        (rule.kind === 'vendor' && (vendor === rule.value || vendorHandle === normalizeHandle(rule.value))) ||
        (rule.kind === 'tag' && tags.indexOf(rule.value) !== -1);

      if (matches) return pinRules.productIds.length + i;
    }

    return Infinity;
  }

  function ensureStyles() {
    if (document.getElementById('InfiniteScrollStyles')) return;
    const style = document.createElement('style');
    style.id = 'InfiniteScrollStyles';
    style.textContent = `
      .infinite-scroll-sentinel {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 1px;
        padding: 2rem 0;
        grid-column: 1 / -1;
      }
      .infinite-scroll-sentinel .loading__spinner { display: flex; }
      .pagination.infinite-scroll-hidden { display: none; }
    `;
    document.head.appendChild(style);
  }

  function buildSpinner() {
    const wrap = document.createElement('div');
    wrap.className = 'loading__spinner hidden';
    wrap.innerHTML = `
      <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
      </svg>`;
    return wrap;
  }

  class DawnInfiniteScroll {
    constructor(root) {
      this.root = root; // #ProductGridContainer
      this.collection = root.querySelector(SELECTORS.collection);
      // this.loading = false;
      // this.nextUrl = null;
      this.loading = false;
      this.prefetching = false;
      this.prefetchComplete = false;
      this.nextUrl = null;
      this.observer = null;
      this.sentinel = null;
      this.spinner = null;
      this.abortController = null;
      this.list = null; 
      this.productIdSet = null; 
      this.pinRules = parsePinParam();

      // scrollEnabled gates the load-more-on-scroll behavior only. Pin
      // sorting is independent of it and runs regardless (see setup()).
      this.scrollEnabled = root.dataset.infiniteScroll !== 'false' && 'IntersectionObserver' in window;

      this.setup();
    }

    // setup() {
    // ensureStyles();

    // this.captureNextUrl();
    // this.hideNativePagination();

    // // Resolve the list and apply pin sort unconditionally — a single-page
    // // collection (no pagination), or a collection with infinite scroll
    // // disabled, still needs pin= ordering applied.
    // this.resolveGridState();

    // if (!this.scrollEnabled || !this.nextUrl) {
    //     return;
    // }

    // this.mountSentinel();
    // this.observeSentinel();
    // }

    setup() {
  ensureStyles();

  this.captureNextUrl();
  this.hideNativePagination();

  if (hasActivePinRules(this.pinRules)) {
    this.createPinLoadingOverlay();

    this.resolveGridState();

    this.prefetchAllPinnedPages()
      .finally(() => {
        // Final sorting after all pages/products are loaded.
        this.applyPinSort();

        // Reveal the completed grid.
        requestAnimationFrame(() => {
          document.documentElement.classList.remove('has-pin-param');
          this.removePinLoadingOverlay();
        });

        if (!this.nextUrl) {
          this.teardown();
        }
      });

    return;
  }

  // No pin parameter → show grid normally.
  document.documentElement.classList.remove('has-pin-param');

  if (!this.scrollEnabled || !this.nextUrl) {
    return;
  }

  this.resolveGridState();
  this.mountSentinel();
  this.observeSentinel();
}
createPinLoadingOverlay() {
  if (!hasActivePinRules(this.pinRules)) return;
  if (document.getElementById('PinLoadingOverlay')) return;

  document.documentElement.classList.add('pin-loading-active');

  const overlay = document.createElement('div');
  overlay.id = 'PinLoadingOverlay';
  overlay.className = 'pin-loading-overlay';

  const spinner = buildSpinner();
  spinner.classList.remove('hidden');

  overlay.appendChild(spinner);
  document.body.appendChild(overlay);
}

removePinLoadingOverlay() {
  const overlay = document.getElementById('PinLoadingOverlay');

  if (overlay) {
    overlay.remove();
  }

  document.documentElement.classList.remove('pin-loading-active');
}

    teardown() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      if (this.abortController) {
        this.abortController.abort();
        this.abortController = null;
      }
      if (this.sentinel && this.sentinel.parentNode) {
        this.sentinel.parentNode.removeChild(this.sentinel);
      }
      this.sentinel = null;
      this.spinner = null;
      this.loading = false;
      this.nextUrl = null;
      this.list = null;
      this.productIdSet = null;
    }

    captureNextUrl() {
      const nextLink = this.root.querySelector(SELECTORS.nextLink);
      this.nextUrl = nextLink && nextLink.href ? nextLink.href : null;
    }

    hideNativePagination() {
      const pagination = this.root.querySelector(SELECTORS.pagination);
      if (pagination) pagination.classList.add('infinite-scroll-hidden');
    }

    resolveList() {
      let list = this.root.querySelector(SELECTORS.productList);
      if (list) return list;
      if (this.collection && this.collection.querySelector(SELECTORS.gridItem)) {
        return this.collection;
      }
      return null;
    }

    // Resolves this.list/this.productIdSet and applies pin sort. Runs on
    // every collection page load regardless of whether there's a next page,
    // so pin= ordering also works on small, single-page collections.
    resolveGridState() {
      const list = this.resolveList();
      if (!list) return;

      this.list = list;
      this.productIdSet = new Set(
        Array.from(list.querySelectorAll('[data-product-id]')).map((el) => el.dataset.productId)
      );

      this.applyPinSort();
    }

    mountSentinel() {
      if (!this.list) return;

      this.sentinel = document.createElement('div');
      this.sentinel.className = 'infinite-scroll-sentinel';
      this.sentinel.setAttribute('aria-hidden', 'true');
      this.spinner = buildSpinner();
      this.sentinel.appendChild(this.spinner);

      this.list.insertAdjacentElement('afterend', this.sentinel);

      // Pin sort already ran in resolveGridState(); re-apply only to make
      // sure the sentinel itself ends up positioned after the (sorted) list.
      this.applyPinSort();
    }

        observeSentinel() {
        if (!this.sentinel) {
            return;
        }

        this.observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
            this.loadNextPage();
            }
        }, {
            rootMargin: ROOT_MARGIN,
            threshold: 0
        });

        this.observer.observe(this.sentinel);
        }

        async prefetchAllPinnedPages() {
  if (this.prefetching || this.prefetchComplete || !this.nextUrl) {
    return;
  }

  this.prefetching = true;

  try {
    while (this.nextUrl) {
      const currentUrl = this.nextUrl;

      await this.fetchAndAppendPage(currentUrl);

      // Stop if the request didn't produce a new page.
      if (this.nextUrl === currentUrl) {
        this.nextUrl = null;
        break;
      }
    }

    this.prefetchComplete = true;

    // Final sort after ALL collection pages have been discovered.
    this.applyPinSort();

  } catch (error) {
    if (error.name !== 'AbortError') {
      console.error('[infinite-scroll] pinned-page prefetch failed:', error);
    }
  } finally {
    this.prefetching = false;

    this.toggleSpinner(false);

    if (this.sentinel) {
      this.sentinel.remove();
      this.sentinel = null;
      this.spinner = null;
    }
  }
}

fetchAndAppendPage(pageUrl) {
  const requestUrl = this.buildSectionUrl(pageUrl);

  this.toggleSpinner(true);

  if (this.abortController) {
    this.abortController.abort();
  }

  this.abortController = new AbortController();

  return fetch(requestUrl, {
    signal: this.abortController.signal
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(
          `Infinite scroll request failed: ${response.status}`
        );
      }

      return response.text();
    })
    .then((html) => {
      return this.appendPage(html, true);
    });
}

    // Re-sorts the currently loaded grid items per the pin= priority rules.
    // Called after the initial page renders and after every appended page,
    // since infinite scroll keeps adding unpinned/pinned items to `list`.
    applyPinSort() {
      if (!this.list || !hasActivePinRules(this.pinRules)) return;

      const items = Array.from(this.list.children).filter((el) => el.matches(SELECTORS.gridItem));

      const indexed = items.map((item, i) => ({
        item,
        originalIndex: i,
        priority: getPinPriority(item, this.pinRules),
      }));

      indexed.sort((a, b) => {
        if (a.priority !== b.priority) return a.priority - b.priority;
        return a.originalIndex - b.originalIndex;
      });

      indexed.forEach(({ item }) => this.list.appendChild(item));

      if (this.sentinel && this.list.nextElementSibling !== this.sentinel) {
        this.list.insertAdjacentElement('afterend', this.sentinel);
      }
    }

    toggleSpinner(isLoading) {
      if (this.spinner) this.spinner.classList.toggle('hidden', !isLoading);
    }

    buildSectionUrl(pageUrl) {
      const sectionId = this.collection ? this.collection.dataset.id : '';
      const url = new URL(pageUrl, window.location.origin);
      if (sectionId) url.searchParams.set('section_id', sectionId);
      return url.toString();
    }

    // loadNextPage() {
    //   if (this.loading || !this.nextUrl) return Promise.resolve();

    //   this.loading = true;
    //   this.toggleSpinner(true);
    //   this.abortController = new AbortController();

    //   const requestUrl = this.buildSectionUrl(this.nextUrl);
    //   return fetch(requestUrl, { signal: this.abortController.signal })
    //     .then((response) => {
    //       if (!response.ok) throw new Error(`Infinite scroll request failed: ${response.status}`);
    //       return response.text();
    //     })
    //     .then((html) => this.appendPage(html))
    //     .catch((error) => {
    //       if (error.name !== 'AbortError') {
    //         console.error('[infinite-scroll]', error);
    //       }
    //     })
    //     .finally(() => {
    //       this.loading = false;
    //       this.toggleSpinner(false);
    //     });
    // }
    loadNextPage() {
  if (
    this.loading ||
    this.prefetching ||
    !this.nextUrl
  ) {
    return Promise.resolve();
  }

  this.loading = true;
  this.toggleSpinner(true);

  this.abortController = new AbortController();

  const requestUrl = this.buildSectionUrl(this.nextUrl);

  return fetch(requestUrl, {
    signal: this.abortController.signal
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(
          `Infinite scroll request failed: ${response.status}`
        );
      }

      return response.text();
    })
    .then((html) => {
      this.appendPage(html, false);
    })
    .catch((error) => {
      if (error.name !== 'AbortError') {
        console.error('[infinite-scroll]', error);
      }
    })
    .finally(() => {
      this.loading = false;
      this.toggleSpinner(false);
    });
}

    // appendPage(html) {
    //   const doc = new DOMParser().parseFromString(html, 'text/html');
    //   const freshRoot = doc.getElementById('ProductGridContainer');
    //   if (!freshRoot) {
    //     this.nextUrl = null;
    //     this.teardown();
    //     return;
    //   }
    //   const list = this.list || this.resolveList();
    //   const freshList =
    //     freshRoot.querySelector(SELECTORS.productList) ||
    //     (freshRoot.querySelector(SELECTORS.collection) && freshRoot.querySelector(SELECTORS.collection).querySelector(SELECTORS.gridItem)
    //       ? freshRoot.querySelector(SELECTORS.collection)
    //       : null);

    //   if (list && freshList) {
    //     const existingIds = this.productIdSet || (this.productIdSet = new Set(
    //       Array.from(list.querySelectorAll('[data-product-id]')).map((el) => el.dataset.productId)
    //     ));

    //     Array.from(freshList.children).forEach((item) => {
    //       if (!item.matches(SELECTORS.gridItem)) return;

    //       const productId = item.dataset.productId;
    //       if (productId && existingIds.has(productId)) return;
    //       if (productId) existingIds.add(productId);

    //       item.classList.add('scroll-trigger--cancel');
    //       item.querySelectorAll('.scroll-trigger').forEach((el) => el.classList.add('scroll-trigger--cancel'));
    //       list.appendChild(item);
    //     });

    //     this.applyPinSort();
    //   }

    //   const freshNextLink = freshRoot.querySelector(SELECTORS.nextLink);
    //   this.nextUrl = freshNextLink && freshNextLink.href ? freshNextLink.href : null;

    //   if (this.sentinel && list && list.nextElementSibling !== this.sentinel) {
    //     list.insertAdjacentElement('afterend', this.sentinel);
    //   }

    //   if (!this.nextUrl) {
    //     this.teardown();
    //   }

    //   document.dispatchEvent(
    //     new CustomEvent('infinite-scroll:page-loaded', { detail: { root: this.root } })
    //   );
    // }

    appendPage(html, isPrefetch = false) {
  const doc = new DOMParser().parseFromString(html, 'text/html');

  const freshRoot = doc.getElementById('ProductGridContainer');

  if (!freshRoot) {
    this.nextUrl = null;
    return;
  }

  const list = this.list || this.resolveList();

  const freshCollection = freshRoot.querySelector(
    SELECTORS.collection
  );

  const freshList =
    freshRoot.querySelector(SELECTORS.productList) ||
    (
      freshCollection &&
      freshCollection.querySelector(SELECTORS.gridItem)
        ? freshCollection
        : null
    );

  if (list && freshList) {
    const existingIds =
      this.productIdSet ||
      (this.productIdSet = new Set(
        Array.from(
          list.querySelectorAll('[data-product-id]')
        ).map((el) => el.dataset.productId)
      ));

    Array.from(freshList.children).forEach((item) => {
      if (!item.matches(SELECTORS.gridItem)) {
        return;
      }

      const productId = item.dataset.productId;

      /*
       * Prevent duplicate products when Shopify returns
       * overlapping pagination results.
       */
      if (productId && existingIds.has(productId)) {
        return;
      }

      if (productId) {
        existingIds.add(productId);
      }

      item.classList.add('scroll-trigger--cancel');

      item
        .querySelectorAll('.scroll-trigger')
        .forEach((el) => {
          el.classList.add('scroll-trigger--cancel');
        });

      list.appendChild(item);
    });

    /*
     * IMPORTANT:
     *
     * Re-sort immediately after every page is appended.
     *
     * During prefetch this means a vendor/type/tag product
     * discovered on page 3 can immediately move above the
     * previously loaded unpinned products.
     */
    this.applyPinSort();
  }

  const freshNextLink = freshRoot.querySelector(
    SELECTORS.nextLink
  );

  const newNextUrl =
    freshNextLink && freshNextLink.href
      ? freshNextLink.href
      : null;

  this.nextUrl = newNextUrl;

  if (
    this.sentinel &&
    list &&
    list.nextElementSibling !== this.sentinel
  ) {
    list.insertAdjacentElement(
      'afterend',
      this.sentinel
    );
  }

  document.dispatchEvent(
    new CustomEvent(
      'infinite-scroll:page-loaded',
      {
        detail: {
          root: this.root,
          prefetch: isPrefetch
        }
      }
    )
  );

  return this.nextUrl;
}

  }

  const instances = new WeakMap();

    function reinitAll() {
    document.querySelectorAll(SELECTORS.gridContainer).forEach(reinit);
    }

    // Expose globally
    window.initInfiniteScroll = function () {
    requestAnimationFrame(() => {
        reinitAll();
    });
    };

  function reinit(root) {
    const existing = instances.get(root);
    if (existing) existing.teardown();
    instances.set(root, new DawnInfiniteScroll(root));
  }

  function installFacetHook() {
    const tryHook = () => {
      if (typeof window.FacetFiltersForm !== 'function') return false;
      if (typeof FacetFiltersForm.renderProductGridContainer !== 'function') return false;
      if (FacetFiltersForm.__infiniteScrollPatched) return true;

      const original = FacetFiltersForm.renderProductGridContainer;

      FacetFiltersForm.renderProductGridContainer = function patchedRenderProductGridContainer(...args) {
        const result = original.apply(this, args);
        reinitAll();
        return result;
      };

      FacetFiltersForm.__infiniteScrollPatched = true;
      return true;
    };

    if (tryHook()) return;

    const interval = setInterval(() => {
      if (tryHook()) clearInterval(interval);
    }, 50);
    setTimeout(() => clearInterval(interval), 5000);
  }

  function init() {
    reinitAll();
    installFacetHook();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();